import { z } from 'zod';
import { Electrify2515PackageForm } from '@pages/Electrify2515';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/electrify2515/')({
  component: Electrify2515PackageForm,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
